export default __webpack_public_path__ + "img/dDpbGrPH.325e5740.svg";